// removed by extract-text-webpack-plugin
module.exports = {"share-on-social-media-content":"share-on-social-media-content","social-media-button":"social-media-button","btn":"btn","QrCodeWrapper":"QrCodeWrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/ShareOnSocialMedia/Modal.scss
// module id = lL9/
// module chunks = 0